import { useInsertionEffect } from 'react';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
const StopPropagationPlugin = () => {
  const [editor] = useLexicalComposerContext();
  useInsertionEffect(() => {
    const onKeyDown = e => {
      e.stopPropagation();
    };
    return editor.registerRootListener((rootElement, prevRootElement) => {
      if (prevRootElement !== null) {
        prevRootElement.removeEventListener('keydown', onKeyDown);
      }
      if (rootElement !== null) {
        rootElement.addEventListener('keydown', onKeyDown);
      }
    });
  }, [editor]);
};
export default StopPropagationPlugin;